import React, { ReactNode } from 'react';
import { getClassNames } from '../../utils';
import './ContentBox.css';
import withTheme from '../../hocs/withTheme';

type ContentBoxProps = {
    className?: string;
    children?: ReactNode;
    underline?: boolean;
    style?: {
        [key: string]: string,
    },
};

function ContentBox({
    children, className = '', underline = true, style,
}: ContentBoxProps) {
    const contentBoxClassName = getClassNames(
        'Content-box',
        { 'content-box_title': underline },
        className,
    );

    return (
        <div className={contentBoxClassName} style={style}>
            {children}
        </div>
    );
}

export default withTheme(ContentBox);
